<script lang="ts" setup>
import { useCompanyStore } from '@Stores/company.store';
import { useLocationStore } from '@Stores/location.store';
import { ShowcaseLayout, ErrorScreenLayout, SupportEmailLink } from '@Shared';
import useCompanyImageBaseUrl from '@Use/useCompanyImageBaseUrl';

const companyImageBaseUrl = useCompanyImageBaseUrl();
const companyStore = useCompanyStore();
const locationStore = useLocationStore();
</script>

<template>
    <showcase-layout
        :company="companyStore.company"
        :brand="companyStore.brand"
        :location="locationStore.location"
        :company-image-base-url="companyImageBaseUrl"
        show-feature-logo
        show-powered-by
    >
        <error-screen-layout
            :image="'/images/cancelled.svg'"
            image-alt="Request voided"
            title="The sender voided this request"
            image-width="9.25rem"
            image-height="9.25rem">
            <p>
                This e-signature request is no longer active.
            </p>
            <p>
                If you believe this was a mistake or need assistance, please contact your closing team or reach out to
                <support-email-link />.
            </p>
        </error-screen-layout>
    </showcase-layout>
</template>

<style lang="scss" scoped>
@use 'certifid-v2-client-hub-styles' as *;
</style>
